angular.module('ApiUtils.dms.cropData').factory('DjangoCropFactory', ['$resource', function ($resource) {
    return $resource('/api/farm-management/crop/');
}]);